<div class="mainContainer">
  <div class="d-flex flex-column align-items-center genreWrapper">
    <h2 class="headingBL">Genre <span> Unveiled</span></h2>
    <p class="vtext details">
      Virsa provides an array of performing arts courses, spanning theatre,
      tabla, sitar, keyboard, kathak, Hindustani classical vocal, harmonium,
      guitar, flute, Carnatic vocal, and Bharatnatyam. Each program offers
      expert guidance, flexible scheduling, and recognized certification. Dive
      into the rich tapestry of cultural heritage while enhancing your artistic
      prowess. Celebrate the beauty of performing arts with us. Start your
      journey towards mastering the art form of your choice with Virsa today.
    </p>
    <a [routerLink]="['/genre']">
      <div class="btnGlobal--primary">Dive In &gt;&gt;</div>
    </a>
  </div>
  <div class="content">
  <button (click)="scrollLeft()" >
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <div class="wrap" #scrollContent>
    <div
      class="genreCard point"
      routerLink="/genre/genre-details/{{genre.id}}"
      *ngFor="let genre of genrelist; let i = index"
    >
      <div class="genreImg">
        <img
          loading="lazy"
          [src]="getImage(genre.name)"
          [alt]="genre.name"
          class="img"
        />
      </div>
      <h6 class="genreType">{{ genre.name }}</h6>
    </div>
  </div>
  <button (click)="scrollRight()" >
    <mat-icon>keyboard_arrow_right</mat-icon>
  </button>
</div>
</div>
